import { ReactElement } from 'react';

const ArrowRightIcon = (props: TClassNameProps): ReactElement => (
	<svg {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.7564 13.1999L21.7564 7.42731C22.0819 7.05152 22.0819 6.49368 21.7564 6.11789L16.7564 0.345303C16.3948 -0.0721569 15.7632 -0.11745 15.3458 0.244138C14.9283 0.605727 14.883 1.23727 15.2446 1.65473L18.8087 5.76953L1 5.76953C0.447716 5.76953 0 6.21725 0 6.76953C0 7.32182 0.447716 7.76953 1 7.76953L18.814 7.76953L15.2446 11.8905C14.883 12.3079 14.9283 12.9395 15.3458 13.3011C15.7632 13.6626 16.3948 13.6174 16.7564 13.1999Z"
			fill="currentColor"
		/>
	</svg>
);

export default ArrowRightIcon;
